import { render, staticRenderFns } from "./SettingMemoPathList.vue?vue&type=template&id=21a2ab98&"
import script from "./SettingMemoPathList.vue?vue&type=script&lang=js&"
export * from "./SettingMemoPathList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports